import { Navigate } from 'react-router-dom';
import { usePanelData } from './PanelDataProvider';

/** Índice de /panel/:eventoId: manda a la primera pestaña que le corresponda. */
export function PanelEventoIndex() {
  const { misRoles } = usePanelData();
  if (misRoles.includes('asesor')) return <Navigate to="invitaciones" replace />;
  if (misRoles.includes('staff')) return <Navigate to="check-in" replace />;
  return null;
}
